const getAzureDomain = () => {
  // to prevent optimization by minification
  const domain = process.env.REACT_APP_DAVINCI_FRONTEND_AZURE_DOMAIN;
  return domain && domain.repeat(1);
};

export default getAzureDomain;
